var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 94c25.957 0 47-21.043 47-47S78.957 0 53 0 6 21.043 6 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 14.4H92.7c-11.9 0-22.1 7.4-26.2 17.9l7.6 15.9h7.3c6.5 0 11.8-5.3 11.8-11.8l-.2-.5c4.1-1.9 7-6 7-10.8 0 0 5.6-4.2 5.6-10.7Z",
    fill: "#8DD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6 36.4c0 6.5-5.3 11.8-11.8 11.8h-7.3m-7.6-15.9C71 21.8 81.2 14.4 93.1 14.4H106c0 6.5-5.3 11.8-11.8 11.8h-5.1l-22.2 6.1Zm33.5-7.2c0 6.5-5.3 11.8-11.8 11.8h-5.1l16.9-11.8Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.4H1c0 6.5 5.6 10.7 5.6 10.7 0 4.8 2.9 8.9 7 10.8l-.2.5c0 6.5 5.3 11.8 11.8 11.8h7.3l7.6-15.9c-4-10.5-14.2-17.9-26.1-17.9Z",
    fill: "#8DD9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 36.4c0 6.5 5.3 11.8 11.8 11.8h7.3m7.7-15.9c-4.1-10.5-14.3-17.9-26.2-17.9H1.5c0 6.5 5.3 11.8 11.8 11.8h5.1l22.2 6.1ZM7.1 25.1c0 6.5 5.3 11.8 11.8 11.8H24L7.1 25.1Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 78.1c16.016 0 29-12.984 29-29s-12.984-29-29-29-29 12.984-29 29 12.984 29 29 29Z",
    fill: "#D5EFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m37.2 35.4 3.3 6.6c.2.4.6.7 1.1.8l7.3 1.1c1.2.2 1.7 1.6.8 2.5l-5.3 5.2c-.3.3-.5.8-.4 1.3l1.3 7.3c.2 1.2-1 2.1-2.1 1.5l-6.5-3.4c-.4-.2-.9-.2-1.3 0l-6.5 3.4c-1.1.6-2.3-.3-2.1-1.5l1.3-7.3c.1-.5-.1-.9-.4-1.3l-5.3-5.2c-.9-.8-.4-2.3.8-2.5l7.3-1.1c.5-.1.9-.4 1.1-.8l3.3-6.6c.3-1 1.8-1 2.3 0Zm35.2 0 3.3 6.6c.2.4.6.7 1.1.8l7.3 1.1c1.2.2 1.7 1.6.8 2.5l-5.3 5.2c-.3.3-.5.8-.4 1.3l1.3 7.3c.2 1.2-1 2.1-2.1 1.5l-6.5-3.4c-.4-.2-.9-.2-1.3 0l-6.5 3.4c-1.1.6-2.3-.3-2.1-1.5l1.3-7.3c.1-.5-.1-.9-.4-1.3l-5.3-5.2c-.9-.8-.4-2.3.8-2.5l7.3-1.1c.5-.1.9-.4 1.1-.8l3.3-6.6c.2-1 1.8-1 2.3 0Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.022
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel8);
export default __webpack_public_path__ + "static/media/level8.496f184c.svg";
export { ForwardRef as ReactComponent };